<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'LEGAL.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'PRIVACY.TITLE' | translate }}</h1>
      <nav class="ph-legal-nav" aria-label="Legal">
        <a routerLink="/legal/privacy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY.TITLE' | translate }}</a>
        <a routerLink="/legal/privacy-policy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY_POLICY.TITLE' | translate }}</a>
        <a routerLink="/legal/cookie-preferences" routerLinkActive="ph-legal-nav__link--active">{{ 'COOKIES.TITLE' | translate }}</a>
        <a routerLink="/legal/terms" routerLinkActive="ph-legal-nav__link--active">{{ 'TERMS.TITLE' | translate }}</a>
      </nav>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <article class="ph-legal">
        <p class="ph-legal__updated">
          {{ 'PRIVACY.LAST_UPDATED' | translate }}: {{ '2024-03-20' | date:'longDate' }}
        </p>

        <section>
          <h2>{{ 'PRIVACY.WEBSITE_HOST.TITLE' | translate }}</h2>
          <p>propero.io</p>
          <p>Brașov</p>
          <p>România</p>
        </section>

        <section>
          <h2>{{ 'PRIVACY.NOTES.TITLE' | translate }}</h2>
          <p>{{ 'PRIVACY.NOTES.CONTENT_1' | translate }}</p>
          <p>{{ 'PRIVACY.NOTES.CONTENT_2' | translate }}</p>
        </section>

        <section class="ph-legal__contact">
          <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
          <p>{{ 'TERMS.CONTACT.DESCRIPTION' | translate }}</p>
          <p><strong>{{ 'CONTACT.DATA.EMAIL_CONTACT.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.EMAIL_CONTACT.VALUE' | translate: translationParams }}</p>
          <p><strong>{{ 'CONTACT.DATA.PHONE.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.PHONE.VALUE' | translate: translationParams }}</p>
        </section>
      </article>
    </div>
  </section>
</div>
